var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21896",
    "data-name": "\\uADF8\\uB8F9 21896",
    transform: "translate(-759 -1219)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28323",
    "data-name": "\\uC0AC\\uAC01\\uD615 28323",
    width: 40,
    height: 40,
    transform: "translate(759 1219)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21741",
    "data-name": "\\uADF8\\uB8F9 21741",
    transform: "translate(-150 -170.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10169",
    "data-name": "\\uD328\\uC2A4 10169",
    d: "M17.1,100.737V93.113A10.443,10.443,0,0,1,27.26,82.458,10.446,10.446,0,0,1,37.417,93.113v7.625",
    transform: "translate(901.992 1310.543)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10170",
    "data-name": "\\uD328\\uC2A4 10170",
    d: "M15.843,106.6h0a4.377,4.377,0,0,1-4.371-4.383V98.8a4.376,4.376,0,0,1,4.371-4.383,1.726,1.726,0,0,1,1.724,1.728v8.731A1.726,1.726,0,0,1,15.843,106.6Z",
    transform: "translate(901.527 1311.525)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10171",
    "data-name": "\\uD328\\uC2A4 10171",
    d: "M37.6,106.6h0a4.377,4.377,0,0,0,4.371-4.383V98.8A4.376,4.376,0,0,0,37.6,94.415a1.726,1.726,0,0,0-1.724,1.728v8.731A1.726,1.726,0,0,0,37.6,106.6Z",
    transform: "translate(903.531 1311.525)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10257",
    "data-name": "\\uD328\\uC2A4 10257",
    d: "M832.845,1583.123s-1.533,4.157-5.485,3.4",
    transform: "translate(107 -164.998)",
    fill: "none",
    stroke: "#212529",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1224",
    "data-name": "\\uD0C0\\uC6D0 1224",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(929 1418.002)",
    fill: "#ff6a13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarIcon);
export default __webpack_public_path__ + "static/media/SelfSellCarIcon.d42ca240848b0f20f4405c249eb47288.svg";
export { ForwardRef as ReactComponent };